import axios from 'axios';
import {
  CommonTypes,
  Loading,
  TableHeader
} from '../../types/common';
// 公共state
const state: CommonTypes = {
  // 用户信息
  userInfo: {},
  // 检测首页
  checkHomeUrl: '',
  // 退出登录地址
  logoutUrl: '',
  // 路由菜单
  menuIndex: 'index',
  defaultRoute: '',
  cacheMenu: '',
  // 全局加载状态
  loading: {
    isShow: false,
    text: '正在加载...',
    background: 'rgba(0, 0, 0, 0.8)'
  },
  // 固定表头状态
  tableHeader: {
    isShow: false,
    scrollTop: 0,
    scrollLeft: 0
  },
  checkResultList: [],
  menuIsCollapse: false,
  isShowIntro: false,
  uploader: null
};
// 修改state
const mutations = {
  changeUserInfo(states: any, user: object) {
    states.userInfo = user;
  },
  changeCheckHomeUrl(states: any, checkHomeUrl: string) {
    states.checkHomeUrl = checkHomeUrl;
  },
  changeCheckLogoutUrl(states: any, logoutUrl: string) {
    states.logoutUrl = logoutUrl;
  },
  changeDefaultRoute(states: any, defaultRoute: string) {
    states.defaultRoute = defaultRoute;
  },
  changeMenuIndex(states: any, menuIndex: string) {
    states.menuIndex = menuIndex;
  },
  changeCacheMenu(states: any, cacheMenu: string) {
    states.cacheMenu = cacheMenu;
  },
  changeLoading(states: any, loading: Loading|any) {
    Object.keys(loading).forEach((key: string) => {
      states.loading[key] = loading[key];
    });
  },
  changeTableHeader(states: any, tableHeader: TableHeader|any) {
    Object.keys(tableHeader).forEach((key: string) => {
      states.tableHeader[key] = tableHeader[key];
    });
  },
  changeCheckResult(states: any, checkResultList: any) {
    states.checkResultList = checkResultList;
  },
  updateCheckResult(states: any, checkResultList: any) {
    states.checkResultList.forEach((item: any, index: any) => {
      if (checkResultList.checkId === item.checkId) {
        states.checkResultList.splice(index, 1, checkResultList);
      }
    });
  },
  changeMenuIsCollapse(states: any, menuIsCollapse: any) {
    states.menuIsCollapse = menuIsCollapse;
  },
  changeIntro(states: any, intro: any) {
    states.isShowIntro = intro;
  },
  changeUploader(states: any, uploader: any) {
    states.uploader = uploader;
  }
};
// 外部调用修改state
const actions = {
  async setUserInfo(context: any) {
    context.commit('changeLoading', {
      isShow: true,
      text: '正在更新状态信息...'
    });
    return new Promise(async (resolve) => {
      await axios.get('/api/User/CurrentAccount').then((data: any) => {
        context.commit('changeUserInfo', data.result || data.data.result);
        resolve();
      });
      context.commit('changeLoading', {
        isShow: false,
        text: '正在加载...'
      });
    });
  },
  setCheckHomeUrl(context: any) {
    axios.get('/api/System/SystemInfo').then((data: any) => {
      context.commit('changeCheckHomeUrl', data.result.homeUrl);
      context.commit('changeCheckLogoutUrl', data.result.logoutUrl);
    });
  },
  setDefaultRoute(context: any, defaultRoute: string) {
    context.commit('changeDefaultRoute', defaultRoute);
  },
  setMenuIndex(context: any, menuIndex: string) {
    context.commit('changeMenuIndex', menuIndex);
  },
  setCacheMenu(context: any, cacheMenu: string) {
    context.commit('changeCacheMenu', cacheMenu);
  },
  setLoading(context: any, loading: Loading|any) {
    context.commit('changeLoading', loading);
  },
  setTableHeader(context: any, tableHeader: TableHeader|any) {
    context.commit('changeTableHeader', tableHeader);
  },
  setCheckResult(context: any, checkResultList: any) {
    context.commit('changeCheckResult', checkResultList);
  },
  updateCheckResult(context: any, checkResultList: any) {
    context.commit('updateCheckResult', checkResultList);
  },
  setMenuIsCollapse(context: any, menuIsCollapse: any) {
    context.commit('changeMenuIsCollapse', menuIsCollapse);
  },
  setIntro(context: any, intro: any) {
    context.commit('changeIntro', intro);
  },
  setUploader(context: any, uploader: any) {
    context.commit('changeUploader', uploader);
  }
};
// 外部调用获取state
const getters = {
  getUserInfo(states: any) {
    return states.userInfo;
  },
  getCheckHomeUrl(states: any) {
    return states.checkHomeUrl;
  },
  getLogoutUrl(states: any) {
    return states.logoutUrl;
  },
  getDefaultRoute(states: any) {
    return states.defaultRoute;
  },
  getMenuIndex(states: any) {
    return states.menuIndex;
  },
  getCacheMenu(states: any) {
    return states.cacheMenu;
  },
  getLoading(states: any) {
    return states.loading;
  },
  getTableHeader(states: any) {
    return states.tableHeader;
  },
  getCheckResult(states: any) {
    return states.checkResultList;
  },
  getMenuIsCollapse(states: any) {
    return states.menuIsCollapse;
  },
  getIntro(states: any) {
    return states.isShowIntro;
  },
  getUploader(states: any) {
    return states.uploader;
  }
};
export default {
  // 公共state
  state,
  // 修改state
  mutations,
  // 外部调用修改state
  actions,
  // 外部调用获取state
  getters
};
